"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var React = _interopRequireWildcard(require("react"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function SvgComponent(props, svgRef) {
  return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    ref: svgRef
  }, props), {}, {
    children: [(0, _jsxRuntime.jsx)("defs", {
      children: (0, _jsxRuntime.jsxs)("radialGradient", {
        id: "prefix__a",
        cx: "50%",
        cy: "54.652%",
        r: "72.567%",
        fx: "50%",
        fy: "54.652%",
        gradientTransform: "matrix(.91313 0 0 1 .043 0)",
        children: [(0, _jsxRuntime.jsx)("stop", {
          offset: "0%",
          stopColor: "#FFB900"
        }), (0, _jsxRuntime.jsx)("stop", {
          offset: "60%",
          stopColor: "#F95D8F"
        }), (0, _jsxRuntime.jsx)("stop", {
          offset: "99.91%",
          stopColor: "#F95353"
        })]
      })
    }), (0, _jsxRuntime.jsxs)("g", {
      fillRule: "nonzero",
      fill: "none",
      children: [(0, _jsxRuntime.jsx)("path", {
        fill: "#283343",
        d: "M4.058 23.209a1.74 1.74 0 01-1.731-1.749 1.74 1.74 0 011.731-1.748 1.74 1.74 0 011.731 1.748 1.74 1.74 0 01-1.731 1.749zm1.737.221c0 .16.278.61.618.61h.22a.155.155 0 00.156-.153v-4.785h-.001a.155.155 0 00-.155-.145H5.95a.154.154 0 00-.154.145h-.001v.39c-.419-.51-1.078-.721-1.74-.721-1.502 0-2.722 1.204-2.722 2.69 0 1.485 1.219 2.689 2.722 2.689.662 0 1.383-.254 1.74-.72zm2.625-.685a2.54 2.54 0 001.432.464c.455 0 .926-.234.926-.64 0-.542-1.026-.626-1.67-.843-.646-.216-1.201-.664-1.201-1.388 0-1.11 1-1.567 1.933-1.567.592 0 1.202.192 1.598.468.136.102.053.22.053.22l-.377.532c-.043.06-.13.108-.224.047-.254-.166-.537-.326-1.05-.326-.633 0-.912.26-.912.582 0 .386.446.508.968.64.91.242 1.903.533 1.903 1.635 0 .977-.925 1.581-1.947 1.581-.775 0-1.435-.218-1.988-.62-.115-.113-.035-.219-.035-.219l.376-.53c.076-.1.173-.065.215-.036zm8.5.685c0 .16.278.61.618.61h.22a.155.155 0 00.156-.153v-4.785h-.001a.155.155 0 00-.155-.145h-.682a.155.155 0 00-.155.145v.39c-.42-.51-1.079-.721-1.74-.721-1.504 0-2.723 1.204-2.723 2.69 0 1.485 1.22 2.689 2.723 2.689.661 0 1.382-.254 1.74-.72zm-1.737-.221a1.74 1.74 0 01-1.731-1.749 1.74 1.74 0 011.731-1.748 1.74 1.74 0 011.732 1.748 1.74 1.74 0 01-1.732 1.749zm8.849.386v-2.476c0-1.395-.891-2.337-2.313-2.337-.678 0-1.233.388-1.43.72v-.004.004c-.001-.337-.278-.533-.618-.533h-.22a.155.155 0 00-.155.153v4.785c.005.08.073.145.155.145h.683l.03-.003c.005 0 .01-.003.014-.004l.015-.005a.056.056 0 00.017-.009l.009-.004.019-.015.003-.003a.152.152 0 00.048-.102v-2.826c0-.75.616-1.357 1.374-1.357.76 0 1.374.607 1.374 1.357v2.362h.001v.464h.001c.005.08.072.145.155.145h.683l.03-.003.012-.003.017-.006.016-.008.01-.005.017-.014.005-.004.017-.02.001-.001a.16.16 0 00.03-.08v-.313zm5.325-.165c0 .16.278.61.618.61h.22a.155.155 0 00.156-.153v-4.785a.156.156 0 00-.156-.145h-.682a.155.155 0 00-.155.145v.39c-.42-.51-1.079-.721-1.74-.721-1.504 0-2.723 1.204-2.723 2.69 0 1.485 1.22 2.689 2.723 2.689.661 0 1.382-.254 1.739-.72zm-1.736-.221a1.74 1.74 0 01-1.732-1.749 1.74 1.74 0 011.732-1.748c.955 0 1.73.783 1.73 1.748a1.74 1.74 0 01-1.73 1.749z"
      }), (0, _jsxRuntime.jsx)("path", {
        fill: "url(#prefix__a)",
        d: "M17.652 5.303c-1.317 0-2.385 1.055-2.385 2.357 0 1.302 1.068 2.357 2.385 2.357 1.318 0 2.386-1.055 2.386-2.357 0-1.302-1.068-2.357-2.386-2.357zm-6.198 0c-1.318 0-2.386 1.055-2.386 2.357 0 1.302 1.068 2.357 2.386 2.357S13.84 8.962 13.84 7.66c0-1.302-1.068-2.357-2.386-2.357zm5.485-2.946c0 1.302-1.068 2.357-2.386 2.357-1.317 0-2.386-1.055-2.386-2.357C12.167 1.055 13.236 0 14.553 0c1.318 0 2.386 1.055 2.386 2.357z",
        transform: "translate(1.333 5.333)"
      })]
    })]
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComponent);
var _default = ForwardRef;
exports["default"] = _default;
//# sourceMappingURL=Asana.js.map